import FormInfoModal from './FormInfoModal';

export default FormInfoModal;
